// Endpoints do módulo Gestão Fee Fixo.
// Backend já implementado sob o prefixo /v1/api/fee-fixo.
// Manter todas as URLs aqui (nunca hardcoded nos arquivos de API).

const BASE = '/v1/api/fee-fixo'

export const feeFixo = {
  // Dashboard / Visão geral (RF-1)
  dashboardResumo: `${BASE}/dashboard/resumo`,

  // Lista de clientes do BI (RF-2)
  clientes: `${BASE}/clientes`,
  /**
   * O depósito do `resultados` da simulação criada pela conversa (spec-007).
   *
   * ★ Existe porque o commit exige `resultados` — calculado AQUI, pelo motor do
   * front — e a interceptação determinística do servidor lê apenas TEXTO:
   * nenhuma frase carrega um objeto de 25 chaves. O cartão deposita, e só então
   * manda a frase de protocolo.
   */
  simulacaoDeposito: `${BASE}/simulacao/deposito`,
  clienteDetalhe: (codigoCliente) => `${BASE}/clientes/${codigoCliente}`,

  // Importação/exportação de clientes (spec-002).
  // GET ?template=true baixa o modelo; GET exporta a base; POST importa.
  clientesImportExport: `${BASE}/clientes/import-export`,

  // Importação da carteira real do diversificador XP/BTG (spec-010, US-4).
  // Rota SEPARADA da de clientes de propósito: o contrato de coluna difere —
  // o `PL` de uma é o patrimônio do cliente, o da outra é o valor da posição.
  // POST save=false devolve o preview; save=true zera o ativo fictício e grava.
  ativosImportExport: `${BASE}/clientes/ativos/import-export`,

  // Relatório PDF de migração (spec-001).
  // POST dispara a geração; GET faz o polling e o download (?download=true).
  relatorios: `${BASE}/relatorios`,
  relatorioStatus: (hash) => `${BASE}/relatorios/${hash}`,

  // Envio do relatório pronto ao cliente, com o PDF anexo (spec-005).
  // É a ação irreversível do módulo: só é chamada depois de o consultor
  // confirmar no card, e nunca pelo agente de IA (ADR-001 da spec-005).
  relatorioEnviarEmail: (hash) => `${BASE}/relatorios/${hash}/enviar-email`,

  // Apresentação gerada por IA, em PDF ou PPTX (spec-001 do
  // project-generate-ppt-with-ai). POST dispara; GET faz o polling do status;
  // GET .../arquivo devolve o envelope nomeado {base64, name, extension}.
  //
  // Rota SEPARADA de `relatorios` de propósito: aquela nasceu de um formato só
  // e o download dela lê a chave fixa `value.pdf` — um contrato de DOIS
  // formatos não pode herdar isso (ver apiFeeFixoRelatorio.js:100-108).
  //
  // Sob `BASE` (REST do módulo) e NÃO sob `BASE_IA`: a apresentação usa IA, mas
  // não é conversa com agente. Declarada lá, viraria uma segunda porta de
  // entrada de IA e acenderia a invariante I-3 da spec-016 (`URL.unit.js`).
  apresentacoes: `${BASE}/apresentacoes`,
  // Os motores DESTE ambiente, com `disponivel` e `motivo` (14/08/2026). A
  // régua é do backend — é o `disponivel()` de cada gerador, o MESMO que o POST
  // usa para recusar. Sem esta rota a tela montava a lista de uma constante
  // local, `disponivel` nunca chegava falso, e o consultor só descobria a falta
  // da credencial depois de esperar a geração inteira.
  //
  // Literal ANTES da rota com path param (`/apresentacoes/{request_id}`) no
  // registro do backend: invertidas, `motores` cairia no parâmetro.
  apresentacaoMotores: `${BASE}/apresentacoes/motores`,
  apresentacaoStatus: (requestId) => `${BASE}/apresentacoes/${requestId}`,
  apresentacaoArquivo: (requestId) =>
    `${BASE}/apresentacoes/${requestId}/arquivo`,

  // Estado do guia (spec-001 do project-onboarding-with-ai-fee-fixo). O
  // agregado que o cartão da entrada renderiza: passos do método, próximo
  // passo e cobertura da carteira. `?visao=profissional|escritorio`, mesma
  // leitura do `/clientes` — quem promove para a visão ampla é o backend.
  //
  // Sob `BASE` (REST do módulo) e NÃO sob `BASE_IA`: o cartão é
  // DETERMINÍSTICO. Ele existe justamente para que as contagens da entrada não
  // dependam do que um modelo diz — declarar este endpoint no motor de IA
  // abriria a segunda porta que a invariante I-3 da spec-016 proíbe
  // (`URL.unit.js`) e amarraria o número ao LLM.
  guiaEstado: `${BASE}/guia/estado`,

  // A esteira de UM cliente (spec-002, [T004]) — `?id_cliente_app=<int>`, o
  // parâmetro canônico. Mesmo payload em duas superfícies: a ficha do cliente
  // (`profile-esteira.vue`) e a tool de leitura da conversa. Derivar de novo em
  // qualquer uma delas seria a segunda fonte de verdade que a AC-7.4 proíbe.
  //
  // Sob `BASE` pela mesma razão do `guiaEstado` acima: a esteira toca
  // compliance, e estado regulatório que passe por LLM deixa de ser medição.
  // Declarado sob `BASE_IA`, acenderia a invariante I-3 (`URL.unit.js`).
  guiaEstadoCliente: `${BASE}/guia/estado-cliente`,

  // Carteira de UM cliente pelo extrato anexado na conversa (spec-004).
  // POST /upload aceita o anexo (multipart, 1-10 arquivos) e agenda a leitura;
  // GET /status é o polling do card; confirmar e cancelar são as duas saídas
  // do preview — endpoints SEPARADOS de propósito, porque são escritas
  // diferentes com desfechos diferentes (despachar por `acao` no corpo é
  // anti-pattern do repo, e o backend as registrou assim).
  //
  // Sob `BASE` (REST do módulo) e NÃO sob `BASE_IA`: o anexo é affordance da
  // TELA do chat, mas o transporte é HTTP autenticado próprio (ADR-001 da
  // spec-005, repetido no D1 desta spec). Declarado no motor de IA, viraria a
  // segunda porta de entrada que a invariante I-3 da spec-016 proíbe
  // (`URL.unit.js`) — e o LLM está fora deste caminho inteiro.
  carteiraChatUpload: `${BASE}/clientes/carteira-chat/upload`,
  carteiraChatStatus: (uploadId) =>
    `${BASE}/clientes/carteira-chat/${uploadId}/status`,
  carteiraChatConfirmar: (uploadId) =>
    `${BASE}/clientes/carteira-chat/${uploadId}/confirmar`,
  carteiraChatCancelar: (uploadId) =>
    `${BASE}/clientes/carteira-chat/${uploadId}/cancelar`,

  // Análises persistidas (RF-4)
  analises: `${BASE}/analises`,
  analiseDetalhe: (id) => `${BASE}/analises/${id}`,

  // Pipeline de Oportunidades (novo sistema via CRM oportunidades).
  oportunidadesPipelineInit: `${BASE}/oportunidades/pipeline/init`,
  oportunidades: `${BASE}/oportunidades`,

  // Premissas do escritório (spec-017) — take rates, cashback, alocações, fee,
  // giro, ROA e taxa padrão. Fonte única: o front não guarda mais o próprio
  // default. GET é de todo profissional (o engine precisa dos valores para
  // calcular); PUT é só do gestor, barrado no BACKEND — a tela não é a barreira.
  //
  // Sob `BASE` (REST do módulo) e NÃO sob `BASE_IA`: premissa não é conversa
  // com agente. Declarada lá, viraria uma segunda porta de entrada de IA e
  // acenderia a invariante I-3 da spec-016 (`URL.unit.js`).
  premissas: `${BASE}/premissas`,
  premissasHistorico: `${BASE}/premissas/historico`,

  // Role play falado do discurso de migração (spec-018).
  //
  // Tudo sob `BASE` (REST do módulo) e NÃO sob `BASE_IA`: o ensaio conversa com
  // um LLM, mas não é uma porta de chat — a persona e o motor são os mesmos da
  // rota dedicada, e declarar isto lá abriria a segunda porta que a invariante
  // I-3 da spec-016 existe para impedir (`URL.unit.js`).
  //
  // O turno tem TRÊS endpoints, um por etapa (transcrever → responder →
  // sintetizar). Um endpoint só seguraria a thread por 5 a 8 segundos e
  // esconderia justamente o progresso que a [US-2] manda mostrar na tela.
  roleplaySessoes: `${BASE}/roleplay/sessoes`,
  roleplaySessao: (idSessao) => `${BASE}/roleplay/sessoes/${idSessao}`,
  roleplayTranscricao: (idSessao) =>
    `${BASE}/roleplay/sessoes/${idSessao}/transcricao`,
  roleplayTurnos: (idSessao) => `${BASE}/roleplay/sessoes/${idSessao}/turnos`,
  roleplayFala: (idSessao, ordem) =>
    `${BASE}/roleplay/sessoes/${idSessao}/turnos/${ordem}/fala`,
  roleplayTurnoTranscricao: (idSessao, ordem) =>
    `${BASE}/roleplay/sessoes/${idSessao}/turnos/${ordem}/transcricao`,
  roleplayAudio: (idSessao, ordem) =>
    `${BASE}/roleplay/sessoes/${idSessao}/turnos/${ordem}/audio`,
  roleplayEncerramento: (idSessao) =>
    `${BASE}/roleplay/sessoes/${idSessao}/encerramento`,
  // A nota que faltou (spec-024, achado A2): avalia um ensaio JÁ ENCERRADO que
  // ficou sem nota. Rota SEPARADA do encerramento porque a operação é outra —
  // esta não fecha sessão nenhuma e recusa sessão em andamento; o encerramento
  // fecha e decide o terminador. O backend é idempotente: com a nota já
  // gravada ele a devolve sem chamar o modelo de novo.
  roleplayAvaliacao: (idSessao) =>
    `${BASE}/roleplay/sessoes/${idSessao}/avaliacao`,
  roleplayQuota: `${BASE}/roleplay/quota`,

  // Conversa fluida (spec-020). Só DUAS rotas novas para o front: o token que
  // abre a conversa direto com a plataforma e o encerramento que reconcilia o
  // transcript e fecha a nota. O áudio nunca passa pelo nosso backend.
  //
  // ⚠️ Sob `BASE` (`/v1/api/fee-fixo`) e não sob o `/v2/api/fee-fixo` que
  // `contracts/api.md §1` escreve: o blueprint do módulo é registrado com
  // `AAWZ_FEE_FIXO_ROUTES_PREFIX = '/v1/api/fee-fixo'`
  // (`aawz_fee_fixo/routes/routes.py:12`), e não existe nenhuma rota `v2` no
  // backend. Seguir o contrato ao pé da letra daria 404 em toda chamada.
  //
  // O terceiro endpoint do contrato — o custom LLM (`§2`) — NÃO entra aqui de
  // propósito: o consumidor dele é a plataforma, com segredo no header, e
  // declará-lo no mapa do front seria publicar uma porta de IA que o navegador
  // não deve nem conhecer.
  roleplayFluidaToken: (idSessao) =>
    `${BASE}/roleplay/sessoes/${idSessao}/fluida/token`,
  roleplayFluidaEncerramento: (idSessao) =>
    `${BASE}/roleplay/sessoes/${idSessao}/fluida/encerramento`,
}

// Especialista Fee-Based (spec-003). ★ [spec-010 T030] Até aqui era a rota
// DEDICADA do motor de IA (`/fee-fixo/chat`): agente e origem vinham do
// próprio endpoint, não do corpo. A spec-010 (D6/ADR-30, US-7) aposenta as
// rotas dedicadas — o roteamento passa a ser do Supervisor, e o drawer usa a
// MESMA porta única `/chat` de qualquer outra superfície, dizendo apenas DE
// ONDE fala via `origem_modulo` no corpo (`constants/OrigemDoModulo.js`,
// enviado por `apiFeeFixoIa.js:perguntar`). Status, reconnect e cancel
// continuam no motor comum, como antes.
const BASE_IA = '/api/v1/intelligence-v2'

export const feeFixoIa = {
  chat: `${BASE_IA}/chat`,
  chatStatus: (id) => `${BASE_IA}/chat/${id}/status`,
  chatReconnect: (id) => `${BASE_IA}/chat/${id}/reconnect`,
  chatCancel: (id) => `${BASE_IA}/chat/${id}/cancel`,
}

export default feeFixo
